import { db } from "../firebase";
import { add, sub } from "date-fns";
import { ref } from "vue";
// function nextDays() {
//   return {days: 14}
// }
export default function () {
  // const nextDays = { days: 14 };
  // const getUpcomingEvents = async (username, nextDays = { days: 15 }) => {
  //   return new Promise((resolve) => {
  //     db.collection("slots")
  //       .where("host", "==", username)
  //       .where("date", ">=", new Date())
  //       .where("date", "<=", add(new Date(), nextDays))
  //       .onSnapshot((res) => {
  //         //   let events = new Set();
  //         let events = [];
  //         res.forEach((doc) => {
  //           console.log("ELement", doc.data());
  //           // events.add(doc.data());
  //           events.push(doc.data());
  //         });
  //         console.log("events", events);
  //         resolve(events);
  //       });
  //   });
  // };
  const upcomingEventsRealTime = ref([]);
  const pastEventsRealTime = ref([]);
  const allEventsRealTime = ref([]);
  const eventsWithinRange = ref([]);

  const getUpcomingEvents = async (username, nextDays = { days: 15 }) => {
    try {
      let events = [];
      const resp = await db
        .collection("slots")
        .where("host", "==", username)
        .where("date", ">=", new Date())
        .where("date", "<=", add(new Date(), nextDays))
        .get();
      resp.forEach((doc) => {
        events.push({ ...doc.data(), id: doc.id });
      });
      // console.log("Fetch events", events);
      return events;
    } catch (err) {
      // console.log("Fetch data error", err);
    }
    // });
  };

  const getAllEventsRealTime = (username) => {
    db.collection("slots")
      .where("host", "==", username)
      // .where("date", ">=", startDate)
      // .where("date", "<=", endDate)
      .onSnapshot((res) => {
        //   let events = new Set();
        let events = [];
        res.forEach((doc) => {
          // console.log("ELement", doc.data());
          // events.add(doc.data());
          events.push({ ...doc.data(), id: doc.id });
        });
        console.log("events", events);
        // resolve(events);
        allEventsRealTime.value = events;
      });
  };

  const getEventsWithinRange = async (username, startDate, endDate) => {
    // db.collection("slots")
    //   .where("host", "==", username)
    //   .where("date", ">=", startDate)
    //   .where("date", "<=", endDate)
    //   .onSnapshot((res) => {
    //     //   let events = new Set();
    //     let events = [];
    //     res.forEach((doc) => {
    //       // console.log("ELement", doc.data());
    //       // events.add(doc.data());
    //       events.push({ ...doc.data(), id: doc.id });
    //     });
    //     // console.log("events", events);
    //     // resolve(events);
    //     eventsWithinRange.value = events;
    //   });
    try {
      const resp = await db
        .collection("slots")
        .where("host", "==", username)
        .where("date", ">=", startDate)
        .where("date", "<=", endDate)
        .get();
      // console.log("res", resp);
      let events = [];
      resp.forEach((doc) => {
        events.push({ ...doc.data(), id: doc.id });
        // events = doc.data();
      });
      // return events;
      console.log("data events", events);
      eventsWithinRange.value = events;
    } catch (error) {
      console.log("error", error);
      // return [];
    }
  };

  const getUpcomingEventsRealTime = (username, nextDays = { days: 30 }) => {
    // let events = [];
    db.collection("slots")
      .where("host", "==", username)
      .where("date", ">=", new Date())
      .where("date", "<=", add(new Date(), nextDays))
      .onSnapshot((res) => {
        //   let events = new Set();
        let events = [];
        res.forEach((doc) => {
          // console.log("ELement", doc.data());
          // events.add(doc.data());
          events.push({ ...doc.data(), id: doc.id });
        });
        // console.log("events", events);
        // resolve(events);
        upcomingEventsRealTime.value = events;
      });
  };

  const getPastEventsRealTime = (username, limitTime) => {
    // let events = [];
    // console.log("past ", pastDays);
    console.log("imit time", limitTime);
    let now = new Date();
    // let startDate = limitTime > 0 ? sub(now, { days: limitTime }) : 0;
    // console.log("start date", startDate);
    db.collection("slots")
      .where("host", "==", username)
      .where("date", "<", new Date())
      .where("date", ">", sub(now, { days: limitTime }))
      // .where("date", "<=", add(new Date(), nextDays))
      .onSnapshot((res) => {
        //   let events = new Set();
        let events = [];
        res.forEach((doc) => {
          // console.log("ELement", doc.data());
          // events.add(doc.data());
          events.push({ ...doc.data(), id: doc.id });
        });
        // console.log("events", events);
        // resolve(events);
        pastEventsRealTime.value = events;
      });
  };
  const addEvent = async (event) => {
    try {
      const doc = await db.collection("slots").add(event);
      return doc;
    } catch (err) {
      console.log("Add event error", err);
    }
    // db.collection("slots")
    //   .add(event)
    //   .then((doc) => {
    //     return doc;
    //   })
    //   .catch((err) => console.log(err));
  };

  const removeEvent = async (eventId) => {
    try {
      await db.collection("slots").doc(eventId).delete();
      return "success";
    } catch (error) {
      return error;
    }
  };

  const getPublicUserData = async (username) => {
    // console.log("user name", username);
    try {
      const resp = await db
        .collection("users")
        .where("username", "==", username)
        .get();
      // console.log("res", resp);
      let userData;
      resp.forEach((doc) => {
        userData = doc.data();
      });
      return userData;
    } catch (error) {
      console.log("error", error);
      return [];
    }
  };

  return {
    getUpcomingEvents,
    addEvent,
    removeEvent,
    getUpcomingEventsRealTime,
    getPastEventsRealTime,
    pastEventsRealTime,
    upcomingEventsRealTime,
    allEventsRealTime,
    getPublicUserData,
    getAllEventsRealTime,
    getEventsWithinRange,
    eventsWithinRange,
  };
}
